import {createSlice} from '@reduxjs/toolkit'

import {uuid} from '../../../../commons/src/services/uuid'

import {ToastType} from '../../../../commons/src/types'
import type {Toast} from '../../types'

export interface ToastState {
  toasts: Toast[]
}

const initialState: ToastState = {
  toasts: [],
}

const defaultTimeouts: {[key: string]: undefined | number} = {
  [ToastType.DEFAULT]: 5 * 1000,
  [ToastType.ERROR]: 10 * 1000,
  [ToastType.WARNING]: 10 * 1000,
  [ToastType.PROGRESS]: undefined,
}

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: create => ({
    showToast: create.preparedReducer(
      ({
        content,
        type = ToastType.DEFAULT,
        timeout,
        id = uuid(),
      }: {
        content: string
        type?: ToastType
        timeout?: number
        id?: string
      }): {payload: Toast} => ({
        payload: {
          id,
          content,
          type,
          timeout: timeout ?? defaultTimeouts[type],
        },
      }),
      (state, action) => {
        const toast = action.payload
        const existingToast = state.toasts.find(t => t.id === toast.id)

        // If toast already exists, update it
        if (existingToast) {
          existingToast.content = toast.content
          existingToast.type = toast.type
          existingToast.timeout = toast.timeout
        } else {
          state.toasts = [toast, ...state.toasts]
        }
      }
    ),
    hideToast: create.reducer<{id: string}>((state, action) => {
      state.toasts = state.toasts.filter(toast => toast.id !== action.payload.id)
    }),
    hideAllToasts: create.reducer(state => {
      state.toasts = []
    }),
  }),
})

export const {showToast, hideToast, hideAllToasts} = toastSlice.actions

export default toastSlice.reducer
